import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, Close } from "@air/next-icons";
import { Chip } from "@air/primitive-chip";
import { Combobox, ComboboxContent, ComboboxEmpty, ComboboxInput, ComboboxInputTrigger, ComboboxItem, ComboboxList, ComboboxLoading } from "@air/primitive-combobox";
import { IconButton } from "@air/primitive-icon-button";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo, useCallback, useState } from "react";
export const StringSelect = /*#__PURE__*/ memo((param)=>{
    let { id, placeholder, values, selectedValues, onSelectionChange, isLoading, onInputChange, isSingleSelect } = param;
    const [searchValue, setSearchValue] = useState("");
    const onRemoveValue = useCallback((value)=>{
        onSelectionChange(selectedValues.filter((val)=>val !== value));
    }, [
        onSelectionChange,
        selectedValues
    ]);
    const onValueClick = useCallback((value)=>{
        if (selectedValues.some((val)=>val === value)) {
            onRemoveValue(value);
        } else {
            if (isSingleSelect) {
                onSelectionChange([
                    value
                ]);
            } else {
                onSelectionChange([
                    ...selectedValues,
                    value
                ]);
            }
        }
    }, [
        isSingleSelect,
        onRemoveValue,
        onSelectionChange,
        selectedValues
    ]);
    const onValueChange = useCallback((value)=>{
        setSearchValue(value);
        onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(value);
    }, [
        onInputChange
    ]);
    return /*#__PURE__*/ _jsxs(Combobox, {
        children: [
            /*#__PURE__*/ _jsx(ComboboxInputTrigger, {
                "data-id": id,
                children: selectedValues.length > 0 ? selectedValues.map((value)=>/*#__PURE__*/ _jsxs(Chip, {
                        "data-id": value,
                        shape: "rounded",
                        size: "medium",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "truncate",
                                children: value
                            }),
                            /*#__PURE__*/ _jsx(IconButton, {
                                appearance: "ghost",
                                color: "grey",
                                "data-testid": "REMOVE_TAG_BUTTON",
                                "data-id": value,
                                icon: Close,
                                label: "Remove smart tag",
                                onClick: (event)=>{
                                    event.stopPropagation();
                                    onRemoveValue(value);
                                },
                                size: "extra-small"
                            })
                        ]
                    }, value)) : /*#__PURE__*/ _jsx("span", {
                    className: "text-14 text-grey-12",
                    children: placeholder
                })
            }),
            /*#__PURE__*/ _jsxs(ComboboxContent, {
                className: "max-h-[min(320px,var(--radix-popover-content-available-height))] w-[var(--radix-popover-trigger-width)]",
                sideOffset: 4,
                shouldFilter: false,
                children: [
                    /*#__PURE__*/ _jsx(ComboboxInput, {
                        onValueChange: onValueChange,
                        placeholder: "Search...",
                        value: searchValue
                    }),
                    isLoading ? /*#__PURE__*/ _jsx(ComboboxLoading, {
                        children: "Loading..."
                    }) : /*#__PURE__*/ _jsx(ComboboxEmpty, {
                        children: "No results found."
                    }),
                    /*#__PURE__*/ _jsx(ComboboxList, {
                        children: values.map((value)=>{
                            const isSelected = selectedValues.some((val)=>val === value);
                            return /*#__PURE__*/ _jsxs(ComboboxItem, {
                                onSelect: ()=>onValueClick(value),
                                children: [
                                    isSelected ? /*#__PURE__*/ _jsx(Check, {
                                        className: "size-4 shrink-0 text-blue-9"
                                    }) : /*#__PURE__*/ _jsx("div", {
                                        className: "size-4 shrink-0"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: tailwindMerge("truncate", isSelected ? "opacity-70" : ""),
                                        children: value
                                    })
                                ]
                            }, value);
                        })
                    })
                ]
            })
        ]
    });
});
StringSelect.displayName = "StringSelect";
